<template>
	<div id="wrap">
		<!-- 头部导航 -->
		<AppHeader />
		
		<div class="layout-con">
			<div class="wrap-right">
				<div class="v3-main">
					<keep-alive :include="navTagIndexs">
						<router-view></router-view>
					</keep-alive>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import AppHeader from '../components/AppHeader.vue'

export default {
  name: 'layout',
  components: {
    AppHeader
  },
  computed: {
    ...mapGetters(['navTagIndexs']),
    ...mapState(['isNavMenuOpen'])
  }
}
</script>

<style lang="less">
.v3-main {

}
// #app #wrap, #app #wrap{ display: flex; overflow-y: auto;}
#app{
	width: 100%; height: 100%;
	#wrap{
		width: 100%; height: 100%;
		.wrap-right{
			overflow: hidden;
			.el-row{
					height: 50px; box-sizing: border-box; background: #fff; border-bottom: 1px solid #ededed; display: flex; align-items: center; justify-content: space-between; padding: 0 0 0 14px;
			}
			.myTable{ border: 1px solid #dfe2ea;}
			.searchInfo{ background-color: #f4f4f4; border-bottom: none;}
			.tableStyle{ border: none;}
		}
	}
}
.layout-con{
	width: 100%; 
	padding-top: 0;
	min-height: calc(100vh - 60px);
}

</style>
